const LOADING_HTML = `
<style>
html, body {
  margin: 0;
  background-color: white;
}
@font-face {
  font-family: 'Financier display regular';
  src: url('https://assets.website-files.com/61c4debfe6329744f06c60e1/61c5868913ba323d6cb972a8_financier-display-regular.woff2') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@keyframes spin {
  100% {
      transform:rotate(360deg);
  }
}
.notice {
  display: flex;
  width: 100vw;
  height: 100dvh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media screen and (min-width: 31.25rem) {
    flex-direction: row;
  }
}
.notice > svg {
  animation: spin 1s linear infinite;
  margin-right:0.25rem;
  line-height:1.5rem;
  vertical-align: middle;
}
.notice > svg path:first-child {
  fill: #000000;
}
.notice > svg path:last-child {
  fill: #66DB86;
}
.notice > span {
  font-family: 'Financier display regular', Georgia, sans-serif;
  font-size: 1.5rem;
  vertical-align: middle;
  line-height: 1.5rem;
}
</style>
<div class="notice">
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/>
<path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"></path>
</svg>
<span>Generating preview</span>
</div>`;

export const usePreviewInvitation = ({eventId}) => {
  const onPreviewInvitationClick = (promise) => {
    const invitationUrl = `/event/${eventId}?preview=1&close=1`;
    const win = window.open('', '_blank');
    const viewport = win.document.createElement('meta');
    viewport.name = 'viewport';
    win.document.getElementsByTagName('head')[0].appendChild(viewport);
    viewport.setAttribute('content', 'width=device-width, initial-scale=1');
    win.document.body.innerHTML = LOADING_HTML;
    promise.finally(() => {
      win.location.replace(invitationUrl);
    });
  };

  return {onPreviewInvitationClick};
};
